import util from '@/utils/index';
export default {
	// 时间格式化
	dateTimeFormat(value, cFormat) {
		return util.dateTimeStr(value, cFormat);
	}
};